const meeting = {
  'queue': 'Queue',
  'visit': 'Visit',
  'do-you-want-sign-up-for-visit': 'Are you sure you want to occupy this slot?',
  'do-you-want-cancel-visit': 'Are you sure you want to free this slot?',
  'available-visits': 'Available slots',
  'term-for-hour': 'Slots for hour',
  'select-queue-for-specific-day': 'Select available day for queue: ',
  'localization': 'Localization',
  'term': 'Term',
  'choose-queue': 'Select queue to see available slots',
  'name': 'Queue name',
  'start-date': 'Start date',
  'start-time': 'Start time',
  'duration-of-slot': 'Duration of slot',
  'number-of-slots': 'Number of slots',
  'break-between-slots': 'Break between slots',
  'add-new-queue': 'Add new queue',
  'day': 'Day',
  onlyOneSlot: 'You can occupy only one slot at the time.',
  manySlot: 'You can occupy many slots at once.',
  noSlotsAdmin: 'This queue does not have any free slots. Add new ones!',
  noSlots: 'There are no available slots at this moment.',
  presenceReports: {
    header: 'More options',
    noResults: 'Could not find any occupied slots for given parameters.',
    errors: {
      forbiddenQueue: "You don't have access to any queue!",
      export: 'Wystąpił błąd podczas generowania pliku!',
      general: 'An unexpected error occurred'
    },
    report: {
      headers: {
        name: 'Name',
        surname: 'Surname',
        index: 'Index',
        unitName: 'Unit name',
        unit: 'Unit',
        end_of_studies: 'End of studies',
        date: 'Date',
        hour: 'Hour'
      },
      deltaTime: 'Delta time',
      startDate: 'Start date',
      endDate: 'End Date',
      shortcuts: {
        header: 'Shortcuts',
        options: {
          today: 'Today',
          thisWeek: 'This week',
          thisMonth: 'This month',
          everything: 'Everything'
        }
      },
      export: {
        header: 'Export',
        info1: 'Generating report in format',
        info2: 'This may take a couple of minutes.',
        info3: 'Done!',
        types: {
          csv: 'CSV'
        },
        button: 'Generate'
      }
    }
  }
};

export default meeting;
